import { render } from "./ticketView.vue?vue&type=template&id=1f6b9283&scoped=true"
import script from "./ticketView.vue?vue&type=script&lang=js"
export * from "./ticketView.vue?vue&type=script&lang=js"

import "./ticketView.vue?vue&type=style&index=0&id=1f6b9283&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f6b9283"]])

export default __exports__